import store from '@/core/store/index'

export function $can(permission) {
  return store.getters.permissions.includes(permission)
}

export function $hasProviderFeature(feature) {
  return store.state.app.provider.features
    ? store.state.app.provider.features[feature]
    : false
}

export function $hasFeature(feature) {
  return store.state.app.features ? store.state.app.features[feature] : false
}

export function $hasReleaseFlag(flag) {
  return store.state.app.releaseFlags
    ? store.state.app.releaseFlags[flag] || false
    : false
}

export function $isRole(role) {
  if (!store.state.app.user) {
    return false
  }
  return store.state.app.user.role === role
}

export function $userHasGameLoyaltyFeature() {
  return Boolean(store.state.app.user.loyalty)
}

export function $hasCompanyChannel(feature) {
  return store.state.app.company_channels
    ? store.state.app.company_channels[feature]
    : false
}

export function $hasPlatformChannel(channel) {
  return store.state.app.platformChannels
    ? store.state.app.platformChannels.includes(channel)
    : false
}

export function $hasPlatformActiveAppForChannel(channel) {
  return store.state.app.platformAppsForChannels
    ? !store.state.app.platformAppsForChannels.hasOwnProperty(channel) ||
        store.state.app.platformAppsForChannels[channel]
    : false
}

export function $isAdmin() {
  if (!store.state.app.user) {
    return false
  }

  return [
    'admin',
    'admin-support',
    'admin-viewer',
    'provider-admin',
    'provider-admin-viewer'
  ].includes(store.state.app.user.role)
}

export function $isSuperAdmin() {
  if (!store.state.app.user) {
    return false
  }

  return ['admin', 'admin-support', 'admin-viewer'].includes(
    store.state.app.user.role
  )
}

export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        $can,
        $hasProviderFeature,
        $hasFeature,
        $hasReleaseFlag,
        $isRole,
        $isAdmin,
        $isSuperAdmin
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/VueAcl.js